import { Injectable } from "@angular/core";

@Injectable()
export class Rfc3339DateProvider {
  /*
    date: string in format "20180815T095153"
    returns: Date
   */
  public toDate(date: string) {
    const match = date.match(/(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})/);
    return match
      ? new Date(
          `${match[1]}-${match[2]}-${match[3]}T${match[4]}:${match[5]}:${
            match[6]
          }Z`
        )
      : new Date(0);
  }

  /*
    date: Date
    returns: string in format "20180815T095153"
   */
  public fromDate(date: Date) {
    return (
      `${date.getFullYear()}${date.getMonth()}${date.getDate()}` +
      `T${date.getHours()}${date.getMinutes()}${date.getSeconds()}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/rfc3339date/rfc3339date.ts